// Per-browser device token (spec §7.4). A random id minted once and kept in
// localStorage; sent with every login so the server can bind/approve this device.

const KEY = "mekaboy:device";

export function getDeviceToken(): string {
  try {
    let token = localStorage.getItem(KEY);
    if (!token) {
      token =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `dev-${Math.random().toString(36).slice(2)}-${Date.now()}`;
      localStorage.setItem(KEY, token);
    }
    return token;
  } catch {
    // Storage disabled (private mode) — a volatile token still lets login work
    // when enforcement is off; it just won't persist for approval.
    return `nostore-${Math.random().toString(36).slice(2)}`;
  }
}
